import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/lib/cart";
import { I18nProvider, useI18n } from "@/lib/i18n";
import { Header } from "@/components/shop/Header";
import { Footer } from "@/components/shop/Footer";
import { CartDrawer } from "@/components/shop/CartDrawer";
import { DiscountPopup } from "@/components/shop/DiscountPopup";
import { SmoothScroll, ScrollProgress, Cursor, Intro, PageTransition } from "@/components/fx/Global";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Sale from "@/pages/Sale";
import Admin from "@/pages/Admin";
import Gifts from "@/pages/Gifts";
import About from "@/pages/About";
import B2B from "@/pages/B2B";
import Legal, { LEGAL_PAGES } from "@/pages/Legal";
import { CookieBanner } from "@/components/shop/CookieBanner";
import { Snow } from "@/components/fx/Holiday";

const Pages = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <PageTransition id={pathname}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/collections/:handle" element={<Shop />} />
        <Route path="/products/:handle" element={<Product />} />
        <Route path="/sale" element={<Sale />} />
        <Route path="/gifts" element={<Gifts />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:handle" element={<Article />} />
        <Route path="/about" element={<About />} />
        <Route path="/b2b" element={<B2B />} />
        {LEGAL_PAGES.map((k) => <Route key={k} path={`/${k}`} element={<Legal kind={k} />} />)}
      </Routes>
    </PageTransition>
  );
};

const Shell = () => {
  const { ready } = useI18n();
  return (
    <>
      <Intro ready={ready} />
      {ready && (
        <CartProvider>
          <SmoothScroll />
          <ScrollProgress />
          <Cursor />
          <Snow />
          <Header />
          <main><Pages /></main>
          <Footer />
          <CookieBanner />
          <CartDrawer />
          <DiscountPopup />
        </CartProvider>
      )}
      <Toaster position="top-center" theme="dark" />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <Shell />
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
